// Do not use this for GUIDs, it is only a safe approximation of a random ID forced
// unique document ids
export function simpleUID() {
  return "_" + Math.random().toString(36).substr(2, 9);
}
